import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatCurrency } from '../../utils/formatUtils';

/**
 * Today's activity stats component
 */
export const TodaysActivity = ({ dashboard }) => {
  return (
    <Card className="mt-6 border-gold/20">
      <CardHeader>
        <CardTitle className="font-serif text-lg text-navy">Today's Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center p-4 bg-muted/50 rounded-lg">
            <p className="text-2xl font-bold text-green-600">
              {formatCurrency(dashboard?.revenue?.today_buy_inr || 0)}
            </p>
            <p className="text-xs text-muted-foreground">Today's Bookings</p>
          </div>
          <div className="text-center p-4 bg-muted/50 rounded-lg">
            <p className="text-2xl font-bold text-navy">
              {dashboard?.revenue?.today_buy_count || 0}
            </p>
            <p className="text-xs text-muted-foreground">Transactions</p>
          </div>
          <div className="text-center p-4 bg-muted/50 rounded-lg">
            <p className="text-2xl font-bold text-navy">
              {dashboard?.users?.today || 0}
            </p>
            <p className="text-xs text-muted-foreground">New Users</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TodaysActivity;
